import { render, staticRenderFns } from "./fieldDetailTable.vue?vue&type=template&id=3ff4ce7d&scoped=true&"
import script from "./fieldDetailTable.vue?vue&type=script&lang=js&"
export * from "./fieldDetailTable.vue?vue&type=script&lang=js&"
import style0 from "./../ServerTable/ServerTable.scss?vue&type=style&index=0&id=3ff4ce7d&prod&lang=scss&scoped=true&"
import style1 from "./fieldDetailTable.vue?vue&type=style&index=1&id=3ff4ce7d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff4ce7d",
  null
  
)

export default component.exports